import React from 'react';
import Helmet from 'react-helmet';
import connectToStores from 'fluxible-addons-react/connectToStores';
import { navigateAction } from 'fluxible-router';
import shallowCompare from '../../lib/shallowCompare';
import CustomerStore from '../../stores/CustomerStore';
import StoreStore from '../../stores/StoreStore';
import OrderStore from '../../stores/OrderStore';
import OrderReceipt from '../OrderReceipt';
import styles from './index.sass';

class OrderConfirmation extends React.Component {
  static propTypes = {
    customer: React.PropTypes.object,
    store: React.PropTypes.object,
    order: React.PropTypes.object
  };

  static contextTypes = {
    executeAction: React.PropTypes.func,
    trackEvent: React.PropTypes.func
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidMount() {
    let { order, store } = this.props;
    if(!order) {return;}
    this.context.trackEvent('Order Completed', {
      checkout_id: order.id,
      order_id: order.id,
      affiliation: store.name,
      revenue: parseFloat(order.total_text.replace('$', '')),
      currency: 'USD',
      products: order.items.map((item) => {
        return {
          product_id: item.inventory_record.id,
          name: item.inventory_record.name,
          price: item.inventory_record.current_price,
          quantity: item.quantity
        };
      }).toJS()
    });
  }

  getHelmetProps() {
    let { store } = this.props;
    let title = `Order Confirmation | ${store.name}`;
    return {
      title: title,
      meta: [
        {property: 'og:title', content: title}
      ]
    };
  }

  handleOnClickContinueShoppingButton(e) {
    this.context.executeAction(navigateAction, {url: this.props.store.root_path});
  }

  render() {
    let { customer, order, store } = this.props;
    if(!order) {return null;}
    let continueShoppingButtonProps = {
      className: styles.continueShoppingButton,
      onClick: this.handleOnClickContinueShoppingButton.bind(this)
    };
    let orderReceiptProps = {
      order: order,
      store: store,
      showHeader: false
    };
    return (
      <div className={styles.orderConfirmation}>
        <Helmet {...this.getHelmetProps()} />
        <div className={styles.storeLogo}><img src={store.logo_photo_hash.getClosestToTarget(250)} /></div>
        <div className={styles.innerContainer}>
          <h3 className={styles.header}>Order confirmation</h3>
          <p className={styles.subheader}>Order: #{order.order_number} • {order.formatted_submitted_at} • {customer.email}</p>
          <p className={styles.message}>
            Hey {customer.first_name},
            <br/><br/>
            Your order was successfully placed!
            <br/><br/>
            Thanks for shopping with us today. We emailed you a receipt and will notify you when the order has shipped.
          </p>
          <div className={styles.buttonsContainer}>
            <button {...continueShoppingButtonProps}>Continue shopping</button>
          </div>
        </div>
        <div className={styles.receiptContainer}>
          <p className={styles.receiptHeader}>Order summary</p>
          <OrderReceipt {...orderReceiptProps} />
        </div>
      </div>
    );
  }
}

OrderConfirmation = connectToStores(OrderConfirmation, [OrderStore], (context, props) => {
  return {
    order: context.getStore(OrderStore).getCurrentEntity()
  };
});

export default OrderConfirmation;



// WEBPACK FOOTER //
// banquet/components/OrderConfirmation/index.js